import { StaticImage } from "gatsby-plugin-image";
import styled from "styled-components";
import { Layout } from "../components/layout";
import { Box, Button, Text } from "@vinomofo/components";
import SEO from "../components/seo/seo";
import { navigate } from "gatsby";

const EmStyled = styled.em`
  display: block;
  background-image: linear-gradient(to top, #77b204 4px, #fff 4px);
  background-position: center bottom;
  background-repeat: no-repeat;
  background-size: 40px 4px;
  border: 0;
  color: #fff;
  font-family: "Graphik", sans-serif;
  font-size: 55px;
  font-weight: 500;
  font-style: normal;
  margin: 0;
  margin-top: 10px;
  margin-bottom: 30px;
  padding: 0;
  padding-bottom: 5px;
  vertical-align: baseline;
  line-height: 60px;
  @media ${({ theme }) => theme.mq.max.mobile} {
    font-size: 25px;
  }
`;

const ImageContainer = styled.div`
  margin: 0 auto;
  width: 300px;
  @media ${({ theme }) => theme.mq.max.mobile} {
    width: 200px;
  }
`;

const NotFound = (): JSX.Element => {
  return (
    <Layout>
      <SEO
        title="404"
        pathname="404"
        image="https://res.cloudinary.com/vinomofo/image/upload/v1663843131/assets/404_si70fu.png"
      />
      <Box width="100%" maxHeight="840px" backgroundColor="#111" py="30px">
        <ImageContainer>
          <StaticImage
            src="https://res.cloudinary.com/vinomofo/image/upload/v1663843131/assets/404_si70fu.png"
            alt="404"
            style={{ margin: "20px auto" }}
            formats={["auto", "webp", "avif"]}
            loading="eager"
            layout="fullWidth"
            objectFit="inherit"
          />
        </ImageContainer>
        <Box maxWidth="764px" mx="auto" mb="10px">
          <Text textAlign="center" variant="sm" color="#aaa" lineHeight="1.8em">
            I don’t know who you are&hellip; I don’t know what you want&hellip;{" "}
            <EmStyled>BUT I WILL LOOK FOR YOU.</EmStyled>
          </Text>
          <Text
            textAlign="center"
            style={{ padding: "0 20px" }}
            variant="sm"
            color="#aaa"
            lineHeight="1.8em"
          >
            No seriously, it seems you may or may not have mistyped a URL, or
            found an out-of-date link or search result. In any case, trust me -
            this isn’t the guy you’re looking for.
          </Text>
          <Box textAlign="center" mb="20px" mt="30px">
            <Button
              textAlign="center"
              variant="primary"
              onClick={() => navigate("/wines/")}
              fontWeight={500}
            >
              Take me to wine
            </Button>
          </Box>
        </Box>
      </Box>
    </Layout>
  );
};

export default NotFound;
